/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Plan_ReplaceInputs */

const en_us2_offline_kind_plan_replace = /** @type {(inputs: Offline_Kind_Plan_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise swapped in the plan`)
};

const pt_br2_offline_kind_plan_replace = /** @type {(inputs: Offline_Kind_Plan_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troca de exercício no plano`)
};

const es_419_offline_kind_plan_replace = /** @type {(inputs: Offline_Kind_Plan_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de ejercicio en el plan`)
};

const pt_pt2_offline_kind_plan_replace = /** @type {(inputs: Offline_Kind_Plan_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troca de exercício no plano`)
};

const fr_fr2_offline_kind_plan_replace = /** @type {(inputs: Offline_Kind_Plan_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice remplacé dans le programme`)
};

const de_de2_offline_kind_plan_replace = /** @type {(inputs: Offline_Kind_Plan_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung im Plan getauscht`)
};

const it_it2_offline_kind_plan_replace = /** @type {(inputs: Offline_Kind_Plan_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizio sostituito nella scheda`)
};

/**
* | output |
* | --- |
* | "Exercise swapped in the plan" |
*
* @param {Offline_Kind_Plan_ReplaceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_plan_replace = /** @type {((inputs?: Offline_Kind_Plan_ReplaceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Plan_ReplaceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_plan_replace(inputs)
	if (locale === "es-419") return es_419_offline_kind_plan_replace(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_plan_replace(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_plan_replace(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_plan_replace(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_plan_replace(inputs)
	return en_us2_offline_kind_plan_replace(inputs)
});
export { offline_kind_plan_replace as "offline.kind_plan_replace" }